import { injectElement } from '@libs/utils/html.utils';

const backgroundImage = {
  default: '/blog-images/incut-bg.png',
  large: '/blog-images/incut-bg-large.png',
};

export const isSmallIncut = (el: HTMLElement): boolean => {
  const smallIncutTextLength = 100;
  return el.innerText.length < smallIncutTextLength;
};

export const updateIncutsImage = (): void => {
  const selector = '.incut--wrap';
  const incuts = Array.from(document.querySelectorAll(selector));

  incuts.forEach((incut) => {
    const [img, span] = Array.from(incut.children);

    if (!span) {
      return;
    }
    img?.remove();

    if (isSmallIncut(span as HTMLElement)) {
      incut.classList.add('sm');
      injectElement({
        target: incut as HTMLElement,
        tag: 'button',
        selector: 'blog-banner__button',
        content: 'Learn more',
      });
    }
  });
};

export const replaceDeprecatedIncuts = (): void => {
  const legacyImgSelector = '.blog-banner__link img';

  Array.from(document.querySelectorAll(legacyImgSelector)).forEach((img) => {
    const anchor = img?.parentElement ?? null;
    const container = anchor?.parentElement ?? null;
    const content = anchor?.nextElementSibling;
    img.remove();
    if (!anchor || !container || !content) return;

    const isSmall = isSmallIncut(content as HTMLElement);
    container.style.backgroundImage = isSmall
      ? `url(${backgroundImage.default})`
      : `url(${backgroundImage.large})`;
    anchor.style.backgroundImage = '';
    img.remove();

    if (isSmall) {
      injectElement({
        target: container,
        tag: 'button',
        selector: 'blog-banner__button',
        content: 'Learn more',
      });
      content.classList.add('small');
    }
  });
};
